/**
 * Collection Search Functionality
 * Client-side filtering for products on the collection page
 */
(function() {
  // Store all products for filtering
  let allProducts = [];
  let isInitialized = false;

  // Initialize the functionality when the DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize collection search
    initCollectionSearch();
  });

  function initCollectionSearch() {
    const searchInput = document.getElementById('inventorySearchInput');
    const searchButton = document.getElementById('inventorySearchButton');

    if (!searchInput || !searchButton) return;

    // Store all products on page load
    storeAllProducts();

    // Add event listeners
    searchInput.addEventListener('keyup', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        const searchTerm = this.value.trim();
        if (searchTerm) {
          performClientSideSearch();
          // The search input will be cleared in addSearchFilterTag
        }
      } else {
        // Debounce search as user types
        clearTimeout(searchInput.timer);
        searchInput.timer = setTimeout(function() {
          performClientSideSearch();
        }, 300);
      }
    });

    searchButton.addEventListener('click', function(event) {
      event.preventDefault();
      const searchTerm = searchInput.value.trim();
      if (searchTerm) {
        performClientSideSearch();
        // The search input will be cleared in addSearchFilterTag
      }
    });

    // Check for URL parameters and set initial search value
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('q');
    if (searchParam) {
      // Set the search input value
      searchInput.value = searchParam;

      // Perform the search immediately
      setTimeout(() => {
        performClientSideSearch();
      }, 500); // Small delay to ensure DOM is fully loaded
    }
  }

  function storeAllProducts() {
    // Get all product items
    const productItems = document.querySelectorAll('#CollectionProductGrid .halo-item');

    if (!productItems.length) {
      console.log('No products found on page');
      return;
    }

    // Store each product with its data
    allProducts = Array.from(productItems).map(item => {
      const titleElement = item.querySelector('.product-title');
      const title = titleElement ? titleElement.textContent.trim() : '';

      const vendorElement = item.querySelector('.product-vendor');
      const vendor = vendorElement ? vendorElement.textContent.trim() : '';

      const priceElement = item.querySelector('.price-item--regular');
      const price = priceElement ? priceElement.textContent.trim() : '';

      // Get any other relevant data
      const productData = item.textContent.toLowerCase();

      return {
        element: item,
        title: title.toLowerCase(),
        vendor: vendor.toLowerCase(),
        price: price,
        allText: productData
      };
    });

    console.log(`Stored ${allProducts.length} products for filtering`);
    isInitialized = true;
  }

  function performClientSideSearch() {
    if (!isInitialized) {
      storeAllProducts();
    }

    const searchInput = document.getElementById('inventorySearchInput');
    const searchTerm = searchInput.value.trim().toLowerCase();

    // Show loading indicator
    document.body.classList.add('loading');

    // Update URL without reloading
    updateURLWithSearchTerm(searchTerm);

    // Filter products
    filterProducts(searchTerm);

    // Remove loading indicator
    setTimeout(() => {
      document.body.classList.remove('loading');
    }, 300);
  }

  function filterProducts(searchTerm) {
    if (!allProducts.length) {
      console.log('No products to filter');
      return;
    }

    const haloColumn = document.querySelector('#CollectionProductGrid .halo-column');
    if (!haloColumn) {
      console.error('Could not find product container');
      return;
    }

    // If no search term, show all products
    if (!searchTerm) {
      allProducts.forEach(product => {
        product.element.style.display = '';
      });

      // Update product count
      updateProductCount(allProducts.length, '');
      return;
    }

    // Filter products based on search term
    const filteredProducts = allProducts.filter(product => {
      return product.title.includes(searchTerm) ||
             product.vendor.includes(searchTerm) ||
             product.allText.includes(searchTerm);
    });

    // Show/hide products based on filter
    allProducts.forEach(product => {
      if (filteredProducts.includes(product)) {
        product.element.style.display = '';
      } else {
        product.element.style.display = 'none';
      }
    });

    // If no products match, show message
    if (filteredProducts.length === 0) {
      const noResultsElement = document.createElement('div');
      noResultsElement.className = 'halo-item halo-item-full no-results';
      noResultsElement.innerHTML = `<p>No products found matching "${searchTerm}"</p>`;

      // Remove any existing no-results message
      const existingNoResults = haloColumn.querySelector('.no-results');
      if (existingNoResults) {
        existingNoResults.remove();
      }

      haloColumn.appendChild(noResultsElement);
    } else {
      // Remove any existing no-results message
      const existingNoResults = haloColumn.querySelector('.no-results');
      if (existingNoResults) {
        existingNoResults.remove();
      }
    }

    // Update product count
    updateProductCount(filteredProducts.length, searchTerm);

    console.log(`Found ${filteredProducts.length} products matching "${searchTerm}"`);
  }

  function updateProductCount(count, searchTerm = '') {
    // Update the sidebar filter matches count
    const matchesElement = document.querySelector('.modern-sidebar-filter__title');
    if (matchesElement) {
      matchesElement.textContent = `${count} MATCHES`;
    }

    // Add search term as a filter tag if it exists
    if (searchTerm) {
      addSearchFilterTag(searchTerm);
    }
  }

  function addSearchFilterTag(searchTerm) {
    // Find the active filters container
    const activeFiltersContainer = document.querySelector('.modern-sidebar-filter__active-filters');
    if (!activeFiltersContainer) return;

    // Make sure the refined widgets container is visible
    const refinedWidgetsContainer = document.querySelector('.refined-widgets');
    if (refinedWidgetsContainer) {
      refinedWidgetsContainer.style.display = 'block';
    }

    // Check if a search tag already exists
    const existingSearchTag = activeFiltersContainer.querySelector('[data-search-filter-tag]');
    if (existingSearchTag) {
      // Update existing tag
      existingSearchTag.querySelector('.search-term-text').textContent = searchTerm;
      return;
    }

    // Create a new filter tag
    const filterTag = document.createElement('div');
    filterTag.className = 'modern-sidebar-filter__active-tag';
    filterTag.setAttribute('data-search-filter-tag', '');

    // Create the search term text
    const searchTermText = document.createElement('span');
    searchTermText.className = 'search-term-text';
    searchTermText.textContent = searchTerm;

    // Create the remove button
    const removeButton = document.createElement('span');
    removeButton.className = 'modern-sidebar-filter__active-tag-icon';
    removeButton.textContent = '×';

    // Add event listener to remove button
    removeButton.addEventListener('click', function() {
      // Clear the search
      const searchInput = document.getElementById('inventorySearchInput');
      if (searchInput) {
        searchInput.value = '';
      }

      // Remove the tag
      filterTag.remove();

      // Show all products
      allProducts.forEach(product => {
        product.element.style.display = '';
      });

      // Update product count
      updateProductCount(allProducts.length, '');

      // Update URL
      updateURLWithSearchTerm('');

      // Hide the refined widgets container if no active filters
      const activeFilters = document.querySelectorAll('.modern-sidebar-filter__active-tag');
      if (activeFilters.length === 0 && refinedWidgetsContainer) {
        refinedWidgetsContainer.style.display = 'none';
      }
    });

    // Assemble the tag
    filterTag.appendChild(searchTermText);
    filterTag.appendChild(removeButton);

    // Add the tag to the container
    activeFiltersContainer.appendChild(filterTag);

    // Clear the search input
    const searchInput = document.getElementById('inventorySearchInput');
    if (searchInput) {
      searchInput.value = '';
    }
  }

  function updateURLWithSearchTerm(searchTerm) {
    // Create a URL object from the current URL
    const url = new URL(window.location.href);

    if (searchTerm) {
      // Set the q parameter in the URL
      url.searchParams.set('q', searchTerm);
    } else {
      // Remove the q parameter if no search term
      url.searchParams.delete('q');
    }

    // Update browser history without reloading the page
    history.pushState(
      { searchTerm },
      '',
      url.toString()
    );
  }
})();
